export default __webpack_public_path__ + "static/media/ad_nl.15e43d7a.png";